import { Builder } from '@builder.io/react'
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { HeadingClass, HeadingType } from 'enums'
import React from 'react'
import CustomHeading, { headingTypePropObj, headingClassPropObj } from '../common/heading'

interface SupportItem {
  supportTopicText: string
  supportDetailText: string
  contactEmail: string
  supportAvailableDate: string
  supportAvailableContactNumber: string
}

interface Props {
  backgroundColor: string
  supportTopicTextColor: string
  supportDetailTextColor: string
  supportItems: SupportItem[]
  headingType: HeadingType
  headingClass: HeadingClass
}

const SupportSection = ({
  backgroundColor,
  supportTopicTextColor,
  supportDetailTextColor,
  supportItems,
  headingType,
  headingClass
}: Props) => {
  const supportItemOne = supportItems[0]
  const supportItemTwo = supportItems[1]

  return (
    <div className="bg-white" style={{ backgroundColor }}>
      <div className="mx-auto max-w-7xl py-16 px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-lg md:grid md:max-w-none md:grid-cols-2 md:gap-8">
          <div>
            <CustomHeading
              classList="font-bold tracking-tight"
              headingClass={headingClass}
              headingType={headingType}
              color={supportTopicTextColor}
            >
              {supportItemOne?.supportTopicText}
            </CustomHeading>

            <div className="mt-3">
              <p className="text-lg text-gray-500" style={{ color: supportDetailTextColor }}>
                {supportItemOne?.supportDetailText}
              </p>
            </div>
            <div className="mt-9">
              <div className="flex">
                <div className="flex-shrink-0">
                  <FontAwesomeIcon
                    icon={faPhone}
                    className="h-6 w-6 text-gray-400"
                    aria-hidden="true"
                    style={{ color: supportDetailTextColor }}
                  />
                </div>
                <div className="ml-3 text-base text-gray-500" style={{ color: supportDetailTextColor }}>
                  <p>{supportItemOne?.supportAvailableContactNumber}</p>
                  <p className="mt-1">{supportItemOne?.supportAvailableDate}</p>
                </div>
              </div>
              <div className="mt-6 flex">
                <div className="flex-shrink-0">
                  <FontAwesomeIcon
                    icon={faEnvelope}
                    className="h-6 w-6 text-gray-400"
                    aria-hidden="true"
                    style={{ color: supportDetailTextColor }}
                  />
                </div>
                <div className="ml-3 text-base text-gray-500" style={{ color: supportDetailTextColor }}>
                  <p>{supportItemOne?.contactEmail}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-12 sm:mt-16 md:mt-0">
            <CustomHeading
              classList="font-bold tracking-tight"
              headingClass={headingClass}
              headingType={headingType}
              color={supportTopicTextColor}
            >
              {supportItemTwo?.supportTopicText}
            </CustomHeading>

            <div className="mt-3">
              <p className="text-lg text-gray-500" style={{ color: supportDetailTextColor }}>
                {supportItemTwo?.supportDetailText}
              </p>
            </div>
            <div className="mt-9">
              <div className="flex">
                <div className="flex-shrink-0">
                  {supportItemTwo ? (
                    <FontAwesomeIcon
                      icon={faPhone}
                      className="h-6 w-6 text-gray-400"
                      aria-hidden="true"
                      style={{ color: supportDetailTextColor }}
                    />
                  ) : null}
                </div>
                <div className="ml-3 text-base text-gray-500" style={{ color: supportDetailTextColor }}>
                  <p>{supportItemTwo?.supportAvailableContactNumber}</p>
                  <p className="mt-1">{supportItemTwo?.supportAvailableDate}</p>
                </div>
              </div>
              <div className="mt-6 flex">
                {supportItemTwo ? (
                  <div className="flex-shrink-0">
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      className="h-6 w-6 text-gray-400"
                      aria-hidden="true"
                      style={{ color: supportDetailTextColor }}
                    />
                  </div>
                ) : null}
                <div className="ml-3 text-base text-gray-500" style={{ color: supportDetailTextColor }}>
                  <p>{supportItemTwo?.contactEmail}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Builder.registerComponent(SupportSection, {
  name: 'SupportSection',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'supportTopicTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'supportDetailTextColor',
      type: 'color',
      defaultValue: 'gray'
    },
    {
      ...headingTypePropObj
    },
    {
      ...headingClassPropObj
    },
    {
      name: 'supportItems',
      type: 'list',
      defaultValue: [
        {
          supportTopicText: 'Sales Support',
          supportDetailText: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores impedit perferendis',
          contactEmail: 'support@example.com',
          supportAvailableDate: 'Mon-Fri 8am to 6pm PST',
          supportAvailableContactNumber: '+1 (555) 123 4567'
        }
      ],
      subFields: [
        { name: 'supportTopicText', type: 'text', defaultValue: 'Sales Support' },
        {
          name: 'supportDetailText',
          type: 'text',
          defaultValue: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores impedit perferendis'
        },
        { name: 'contactEmail', type: 'text', defaultValue: 'support@example.com' },
        { name: 'supportAvailableDate', type: 'text', defaultValue: 'Mon-Fri 8am to 6pm PST' },
        { name: 'supportAvailableContactNumber', type: 'text', defaultValue: '+1 (555) 123 4567' }
      ]
    }
  ]
})
